import React from "react";
import Search from "@mui/icons-material/Search";
import Menu from "@mui/icons-material/Menu";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import StarBorder from "@mui/icons-material/StarBorder";
import ArchiveOutlined from "@mui/icons-material/ArchiveOutlined";
import Reply from "@mui/icons-material/Reply";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import CheckBoxOutlineBlank from "@mui/icons-material/CheckBoxOutlineBlank";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import AppIcon from "./DemoAppIcon";

function Avatar({ name, tone = "blue" }) {
  return (
    <span className={"growth-avatar growth-avatar-" + tone} aria-hidden="true">
      {name
        .split(" ")
        .map((word) => word[0])
        .slice(0, 2)
        .join("")}
    </span>
  );
}

function GmailScene({ hiring }) {
  const sender = hiring ? "Jamie Park" : "Alice Chen";
  const subject = hiring
    ? "Founding engineer at Northstar"
    : "A faster customer rollout at Meridian";
  const inbox = hiring
    ? [
        [sender, subject],
        ["Taylor Chen", "Re: Building the product team"],
        ["Alex Morgan", "Re: The infrastructure team"],
        ["Jordan Rivera", "Re: Developer tools at Northstar"],
      ]
    : [
        [sender, subject],
        ["Marcus Reed", "Re: Forma + Northstar"],
        ["Sofia Patel", "Re: Scaling customer onboarding"],
        ["Maya Ellis", "Confirmed: Thursday at 2"],
      ];
  return (
    <div className="work-gmail">
      <header className="growth-app-header">
        <Menu />
        <div className="growth-wordmark">
          <AppIcon id="gmail" />
          Gmail
        </div>
        <div className="growth-search">
          <Search />
          Search mail
        </div>
        <Avatar name="Simon Agent" />
      </header>
      <div className="growth-mail-layout">
        <aside>
          <span className="growth-compose">Compose</span>
          <span className="active">
            Inbox <b>{hiring ? 6 : 12}</b>
          </span>
          <span>Starred</span>
          <span>Snoozed</span>
          <span>Sent</span>
          <span>
            Drafts <b>2</b>
          </span>
          <span className="work-side-label">Labels</span>
          <span className="growth-mail-label">
            {hiring ? "Founding team" : "Customer meetings"}
          </span>
          <span>{hiring ? "Interviewing" : "Qualified accounts"}</span>
        </aside>
        <div className="growth-mail-list">
          <header>
            <strong>Inbox</strong>
            <MoreHoriz />
          </header>
          {inbox.map(([name, title], i) => (
            <div className={i === 0 ? "is-selected" : ""} key={name}>
              <StarBorder />
              <strong>{name}</strong>
              <time>{["10:42", "10:18", "09:51", "09:24"][i]}</time>
              <p>{title}</p>
              <small>
                {i === 0
                  ? "Thanks, that works for me."
                  : "To: Simon at Northstar"}
              </small>
            </div>
          ))}
        </div>
        <section className="growth-email">
          <div className="growth-mail-tools">
            <ArchiveOutlined />
            <StarBorder />
            <MoreHoriz />
            <span>1 of {hiring ? "6" : "12"}</span>
          </div>
          <h4>{subject}</h4>
          <span className="growth-mail-tag">Inbox</span>
          <header>
            <Avatar name={sender} tone="lavender" />
            <div>
              <strong>{sender}</strong>
              <small>
                to Simon <span>10:42 AM</span>
              </small>
            </div>
            <Reply />
          </header>
          <div className="growth-email-copy">
            <p>Hi Simon,</p>
            <p>
              {hiring
                ? "The founding role sounds like a strong fit. I led our distributed systems work and would love to hear more about what you're building."
                : "Your note about our customer rollout was well timed. We're expanding our team and want to get new customers to value faster."}
            </p>
            <p>
              {hiring
                ? "Thursday at 11 works for the technical conversation. Looking forward to meeting the team."
                : "Wednesday at 10 works. Please send an invite and include our head of customer success."}
            </p>
            <p>
              Thanks,
              <br />
              {sender.split(" ")[0]}
            </p>
          </div>
          <div className="growth-email-confirm">
            <CheckCircleOutline />
            <span>
              {hiring ? "Interview time agreed" : "Meeting time agreed"}
              <small>
                {hiring ? "Thu, Sep 10 / 11:00 AM" : "Wed, Sep 9 / 10:00 AM"} /
                Pacific Time
              </small>
            </span>
          </div>
        </section>
      </div>
    </div>
  );
}

function LinkedInScene({ hiring }) {
  const people = hiring
    ? [
        [
          "Jamie Park",
          "Staff Software Engineer",
          "Distributed systems / Platform infrastructure",
          "Built a platform serving 2M users",
          "Shortlisted",
        ],
        [
          "Taylor Chen",
          "Senior Product Engineer",
          "Full-stack engineering / React / TypeScript",
          "Shipped a self-serve product from zero to launch",
          "Shortlisted",
        ],
        [
          "Jordan Rivera",
          "Senior Software Engineer",
          "Developer tools / APIs / Infrastructure",
          "Led developer experience for a team of 40",
          "Shortlisted",
        ],
      ]
    : [
        [
          "Alice Chen",
          "VP of Operations at Meridian",
          "B2B software / 85 employees",
          "Expanding customer operations this quarter",
          "Qualified",
        ],
        [
          "Marcus Reed",
          "Co-founder & CEO at Forma",
          "B2B software / 42 employees",
          "Building a repeatable customer onboarding motion",
          "Qualified",
        ],
        [
          "Sofia Patel",
          "Head of Customer Success at Daylight",
          "B2B software / 120 employees",
          "Hiring across customer success and implementation",
          "Qualified",
        ],
      ];
  return (
    <div className="work-linkedin">
      <header className="growth-app-header">
        <div className="growth-linkedin-brand">
          <strong>Linked</strong>
          <AppIcon id="linkedin" />
        </div>
        <span className="growth-linkedin-product">
          {hiring ? "Recruiter" : "Sales Navigator"}
        </span>
        <div className="growth-search">
          <Search />
          {hiring ? "Founding engineer" : "Operations leaders"}
        </div>
        <Avatar name="Simon Agent" />
      </header>
      <nav className="growth-linkedin-nav">
        <b>{hiring ? "Projects" : "Home"}</b>
        <span>{hiring ? "Talent pool" : "Lead lists"}</span>
        <span>{hiring ? "Jobs" : "Account lists"}</span>
        <span>Messages</span>
        <small>Northstar</small>
      </nav>
      <div className="growth-linkedin-layout">
        <aside>
          <strong>{hiring ? "Talent search" : "Lead filters"}</strong>
          <span className="growth-filter-label">
            {hiring ? "Role" : "Function"}
          </span>
          <span className="growth-filter">
            {hiring ? "Software engineering" : "Operations + Customer success"}
          </span>
          <span className="growth-filter-label">
            {hiring ? "Skills" : "Company size"}
          </span>
          <span className="growth-filter">
            {hiring ? "Distributed systems" : "20-200 employees"}
          </span>
          <span className="growth-filter-label">
            {hiring ? "Experience" : "Industry"}
          </span>
          <span className="growth-filter">
            {hiring ? "Product ownership" : "B2B software"}
          </span>
          <span className="growth-filter-label">Location</span>
          <span className="growth-filter">United States</span>
          <small className="growth-search-saved">
            <CheckCircleOutline /> Search saved
          </small>
        </aside>
        <section>
          <header>
            <div>
              <h4>
                {hiring
                  ? "Founding engineering team"
                  : "Customer operations leaders"}
              </h4>
              <p>
                {hiring
                  ? "12 shortlisted / 3 open roles"
                  : "36 qualified leads / 20-meeting goal"}
              </p>
            </div>
            <span className="growth-blue-label">
              {hiring ? "View project" : "Saved list"}
            </span>
          </header>
          {people.map(([name, title, detail, evidence, status], i) => (
            <article className="growth-person" key={name}>
              <Avatar name={name} tone={["lavender", "blue", "rose"][i]} />
              <div>
                <h5>
                  {name}
                  <small>2nd</small>
                </h5>
                <strong>{title}</strong>
                <p>{detail}</p>
                <span className="growth-person-evidence">{evidence}</span>
              </div>
              <span className="growth-person-status">{status}</span>
            </article>
          ))}
        </section>
      </div>
    </div>
  );
}

function HubSpotScene({ mission }) {
  return (
    <div className="work-hubspot">
      <header className="growth-hubspot-top">
        <AppIcon id="hubspot" />
        <strong>HubSpot</strong>
        <span>CRM</span>
        <span>Sales</span>
        <span>Reporting</span>
        <Search />
        <small>Northstar</small>
      </header>
      <div className="growth-hubspot-layout">
        <aside>
          <strong>CRM</strong>
          <span className="active">Contacts</span>
          <span>Companies</span>
          <span>Deals</span>
          <span>Tasks</span>
          <span>Playbooks</span>
          <span className="work-side-label">Saved views</span>
          <span>Qualified meetings</span>
          <span>Recent activity</span>
        </aside>
        <section>
          <header>
            <div>
              <h4>Contacts</h4>
              <p>36 qualified contacts</p>
            </div>
            <span className="growth-hubspot-action">Create contact</span>
          </header>
          <div className="growth-crm-tabs">
            <b>
              Qualified meetings <span>36</span>
            </b>
            <span>All contacts</span>
            <span>My contacts</span>
          </div>
          <div className="growth-crm-filters">
            <div>
              <Search />
              Search contacts
            </div>
            <span>Lifecycle stage</span>
            <span>Contact owner</span>
          </div>
          <table>
            <thead>
              <tr>
                <th>
                  <CheckBoxOutlineBlank />
                </th>
                <th>Name</th>
                <th>Company</th>
                <th>Status</th>
                <th>Next activity</th>
              </tr>
            </thead>
            <tbody>
              {mission.rows.map(([company, name, status, next]) => (
                <tr key={company}>
                  <td>
                    <CheckBoxOutlineBlank />
                  </td>
                  <td>
                    <strong>{name}</strong>
                  </td>
                  <td>{company}</td>
                  <td>
                    <span
                      className={
                        status === "Meeting booked" ? "growth-crm-booked" : ""
                      }
                    >
                      {status}
                    </span>
                  </td>
                  <td>{next}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="growth-crm-result">
            <CheckCircleOutline />
            <div>
              <strong>8 qualified meetings booked</strong>
              <span>
                Contacts, conversation history, and calendar events connected.
              </span>
            </div>
            <b>8 / 20</b>
          </div>
        </section>
      </div>
    </div>
  );
}

function CalendarScene({ hiring }) {
  const events = hiring
    ? [
        {
          day: 1,
          top: 196,
          name: "Taylor / Product engineering",
          time: "2:00-2:45 PM",
        },
        {
          day: 3,
          top: 49,
          name: "Jamie / Technical interview",
          time: "11:00-11:45 AM",
          selected: true,
        },
        {
          day: 4,
          top: 147,
          name: "Team / Interview debrief",
          time: "1:00-1:30 PM",
        },
      ]
    : [
        {
          day: 1,
          top: 49,
          name: "Forma / Customer discovery",
          time: "11:00-11:30 AM",
        },
        {
          day: 2,
          top: 0,
          name: "Meridian / Customer rollout",
          time: "10:00-10:30 AM",
          selected: true,
        },
        {
          day: 3,
          top: 196,
          name: "Orbit / Customer discovery",
          time: "2:00-2:30 PM",
        },
      ];
  return (
    <div className="work-calendar">
      <header className="growth-app-header">
        <Menu />
        <div className="growth-wordmark">
          <AppIcon id="googlecalendar" />
          Calendar
        </div>
        <span className="growth-calendar-today">Today</span>
        <ChevronLeft />
        <ChevronRight />
        <h4>September 2026</h4>
        <span className="growth-calendar-week">Week</span>
      </header>
      <div className="growth-calendar-layout">
        <aside>
          <strong>September 2026</strong>
          <div className="growth-mini-calendar">
            {"MTWTFSS".split("").map((day, i) => (
              <b key={i}>{day}</b>
            ))}
            {Array.from({ length: 30 }, (_, i) => (
              <span
                className={i === (hiring ? 9 : 8) ? "selected" : ""}
                key={i}
              >
                {i + 1}
              </span>
            ))}
          </div>
          <span className="work-side-label">My calendars</span>
          <span className="growth-calendar-owner">
            <i />
            Simon / Northstar
          </span>
          <span>Team availability</span>
          <small>Pacific Time</small>
        </aside>
        <section>
          <div className="growth-calendar-days">
            <span>GMT-07</span>
            {["MON", "TUE", "WED", "THU", "FRI"].map((day, i) => (
              <div key={day}>
                <small>{day}</small>
                <strong className={i === (hiring ? 3 : 2) ? "selected" : ""}>
                  {i + 7}
                </strong>
              </div>
            ))}
          </div>
          <div className="growth-calendar-grid">
            <div className="growth-calendar-times">
              {["10 AM", "11 AM", "12 PM", "1 PM", "2 PM", "3 PM"].map((t) => (
                <span key={t}>{t}</span>
              ))}
            </div>
            {Array.from({ length: 5 }, (_, day) => (
              <div className="growth-calendar-column" key={day}>
                {events
                  .filter((e) => e.day === day)
                  .map((event) => (
                    <div
                      className={
                        "growth-calendar-event " +
                        (event.selected ? "selected" : "")
                      }
                      key={event.name}
                      style={{ top: event.top }}
                    >
                      <strong>{event.name}</strong>
                      <small>{event.time}</small>
                      <span>Google Meet</span>
                    </div>
                  ))}
              </div>
            ))}
          </div>
          <footer>
            <CheckCircleOutline />
            <strong>
              {hiring
                ? "Technical interview confirmed"
                : "Meridian meeting confirmed"}
            </strong>
            <span>
              {hiring
                ? "Candidate and interview team invited"
                : "Both customer attendees invited"}
            </span>
          </footer>
        </section>
      </div>
    </div>
  );
}

export default function GrowthWorkScenes({ mission, app }) {
  const hiring = mission.id === "hiring";
  if (app === "gmail") return <GmailScene hiring={hiring} />;
  if (app === "linkedin") return <LinkedInScene hiring={hiring} />;
  if (app === "hubspot") return <HubSpotScene mission={mission} />;
  if (app === "googlecalendar") return <CalendarScene hiring={hiring} />;
  return null;
}
